// extracted by mini-css-extract-plugin
module.exports = {"middle":"SecretPage_middle__3AWvC","Image":"SecretPage_Image__3gYO-","Button":"SecretPage_Button__3YIZh","Input":"SecretPage_Input__9QQFl"};